module.exports = __webpack_public_path__ + "img/lawnstarter_hero_yard_mobile.85a7052c.svg";